/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createSelector, select } from '@ngrx/store';
import { FilterState } from '../../../../../models';
import { createFilterStateSelector } from '../create-filter-state-selector/create-filter-state.selector';
import { pipe, filter } from 'rxjs';

export function selectorBody(filterState: FilterState): boolean {
  if (!filterState || !filterState.isInitialized) {
    return null;
  }

  return !filterState.filteredDataIds.length;
}

export const createIsIsEmptyByFilterSelector = (filterInstanceId: string) =>
  pipe(
    select(createSelector(createFilterStateSelector(filterInstanceId), (filterState) => selectorBody(filterState))),
    filter((isEmptyValue) => isEmptyValue !== null),
  );
